module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mb-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.customerList,
      "label": "Select a Customer",
      "item-text": "name",
      "hide-details": "",
      "item-value": "key",
      "clearable": ""
    },
    model: {
      value: (_vm.customerFilter),
      callback: function($$v) {
        _vm.customerFilter = $$v
      },
      expression: "customerFilter"
    }
  })], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": !_vm.customerFilter,
      "type": "info"
    }
  }, [_vm._v("\n    Please Select a Customer\n  ")]), _vm._v(" "), (_vm.customerFilter) ? _c('v-card', [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Filter Vehicles",
      "multiple": "",
      "item-text": "VehicleReg",
      "item-value": "key",
      "items": _vm.vehicles,
      "hide-details": "",
      "chips": "",
      "deletable-chips": "",
      "single-line": "",
      "clearable": "",
      "solo": ""
    },
    model: {
      value: (_vm.vehicleFilter),
      callback: function($$v) {
        _vm.vehicleFilter = $$v
      },
      expression: "vehicleFilter"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Filter Products",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.productTypes,
      "hide-details": "",
      "single-line": "",
      "clearable": "",
      "solo": ""
    },
    model: {
      value: (_vm.productFilter),
      callback: function($$v) {
        _vm.productFilter = $$v
      },
      expression: "productFilter"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "success",
      "dismissible": ""
    },
    model: {
      value: (_vm.exportAlert),
      callback: function($$v) {
        _vm.exportAlert = $$v
      },
      expression: "exportAlert"
    }
  }, [_vm._v("\n    Data copied to clipboard\n  ")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.products,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vehReg))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-transform": "capitalize"
          }
        }, [_vm._v(_vm._s(props.item.warrantyType))]), _vm._v(" "), _c('td', {
          class: {
            error: props.item.warrantyExpired
          }
        }, [_vm._v(_vm._s(props.item.warrantyExpiry))]), _vm._v(" "), _c('td', {
          class: {
            error: props.item.contractExpired
          }
        }, [_vm._v(_vm._s(props.item.contractExpiry))])])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, [_c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('ul', {
          staticStyle: {
            "list-style-type": "none"
          }
        }, [_c('li', [_vm._v("Contract Start: " + _vm._s(_vm._f("formatDate")(props.item.installDate)))]), _vm._v(" "), _c('li', [_vm._v("Contract Term: " + _vm._s(props.item.contractLength) + " " + _vm._s(props.item.contractPeriod))]), _vm._v(" "), _c('li', [_vm._v("Contract Expiry: " + _vm._s(props.item.contractExpiry))]), _vm._v(" "), _c('li', [_vm._v("Warranty Period: " + _vm._s(props.item.warrantyLength) + " " + _vm._s(props.item.warrantyPeriod))]), _vm._v(" "), _c('li', {
          staticStyle: {
            "text-transform": "capitalize"
          }
        }, [_vm._v("Warranty Type: " + _vm._s(props.item.warrantyType))]), _vm._v(" "), _c('li', [_vm._v("Upfront Amount: " + _vm._s(props.item.currency === 'gbp' ? '£' : '€') + _vm._s(props.item.upfrontPayment || '-'))]), _vm._v(" "), _c('li', [_vm._v("Upfront Installation: " + _vm._s(props.item.currency === 'gbp' ? '£' : '€') + _vm._s(props.item.installationPayment || '-'))]), _vm._v(" "), _c('li', [_vm._v("Rental Frequency: " + _vm._s(props.item.rentalFrequency || '-'))]), _vm._v(" "), _c('li', [_vm._v("Rental Amount: " + _vm._s(props.item.currency === 'gbp' ? '£' : '€') + _vm._s(props.item.rentalPayment || '-'))]), _vm._v(" "), _c('li', [_vm._v("Lease Frequency: " + _vm._s(props.item.leaseFrequency || '-'))]), _vm._v(" "), _c('li', [_vm._v("Lease Amount: " + _vm._s(props.item.currency === 'gbp' ? '£' : '€') + _vm._s(props.item.leasePayment || '-'))]), _vm._v(" "), _c('li', [_vm._v("Installation Date: " + _vm._s(_vm._f("formatDate")(props.item.installDate)))]), _vm._v(" "), _c('li', [_vm._v("Project: " + _vm._s(props.item.project))]), _vm._v(" "), _c('li', [_vm._v("Job: "), _c('v-btn', {
          attrs: {
            "small": "",
            "to": {
              path: '/Project/' + _vm.customerFilter + '/' + props.item.job
            },
            "flat": ""
          }
        }, [_vm._v("View Job")])], 1), _vm._v(" "), _c('li', [_c('v-btn', {
          attrs: {
            "small": "",
            "flat": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewDevice(props.item)
            }
          }
        }, [_vm._v("View Devices")])], 1)])])], 1)]
      }
    }], null, false, 1562085603)
  })], 1) : _vm._e(), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "exportData",
      "hidden": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c997041","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products.vue
// module id = 754
// module chunks = 1